/**
 * 2022-02-13
 * origin: https://app.zeplin.io/project/614bed834869303d4a4096e4/screen/61dc3caba7a65728a5d0f923
 * icon卖点组件之No.3
 */
import css from './index.module.scss';
import { TextModule, TextIconCell } from '@/components/ProductDetailComponents';
import EFBlueTick from '@/components/UI/svg/Icons/EFBlueTick';
import { useGlobal } from '@/utils/useGlobal';

const defaultStyle = {
    backColor: 'transparent',
    height: 'auto',
    guideStyle: {
        fontClass: 'font-family-semibold',
        fontWeight: 500,
        color: '#2673ff',
        fontSize: '32px',
        lineHeight: '40px',
        margin: '0 0 10px 0',
        width: '480px',
    },
    titleStyle: { type: 'ls', width: '480px' },
    descStyle: {
        type: 'sl',
        fontClass: 'font-family-semibold',
        color: '#03060b',
        margin: '0 0 120px 0',
        width: '434px',
    },
    textIconStyle: {
        wrapperPadding: '40px 50px',
        wrapperHeight: '400px',
        wrapperBackColor: '#f6f6f8',
        wrapperBorderRadius: '20px',
        fontClassTitle: 'font-family-bold',
        fontWeightDesc: 600,
    },
};
const defaultData = {
    guide: { text: 'Interior / Exterior Design' },
    title: { text: 'Let’s get down to details.' },
    desc: {
        text: 'DELTA Pro is designed inside and out for ease of use, durability and safety. Take a closer look. ',
    },
    items: [
        {
            icon: <EFBlueTick />,
            title: 'Interior Design ',
            des: 'DELTA Pro’s capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ',
            directUrl: '/',
        },
        {
            icon: <EFBlueTick />,
            title: 'Exterior Design ',
            des: 'The exterior is built as one piece with tough ABS plastic. As an added measure of safety, it’s fire resistant too.',
            directUrl: '/',
        },
        {
            icon: <EFBlueTick />,
            title: 'Interior Design ',
            des: 'With a rugged, luggage-like handle, DELTA Pro can be wheeled around with ease. ',
            directUrl: '/',
        },
    ],
};

export default function Third({ data = defaultData, cssStyle = defaultStyle }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const { guide, title, desc, items } = {
        guide: { ...defaultData.guide, ...data.guide },
        title: { ...defaultData.title, ...data.title },
        desc: { ...defaultData.desc, ...data.desc },
        items: data.items,
    };
    cssStyle.guideStyle = {
        ...defaultStyle.guideStyle,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.guideStyle,
    };
    cssStyle.titleStyle = {
        ...defaultStyle.titleStyle,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.titleStyle,
    };
    cssStyle.descStyle = {
        ...defaultStyle.descStyle,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.descStyle,
    };
    cssStyle.textIconStyle = {
        ...defaultStyle.textIconStyle,
        ...{ wrapperBackColor: cssStyle.backColor },
        ...cssStyle.textIconStyle,
    };
    const { backColor, height, guideStyle, titleStyle, descStyle, textIconStyle } = cssStyle;

    return (
        <div className={`${css.sellPointsModule} sellPointsModuleThird`} style={{ background: backColor, height: height }}>
            <div className="container">
                <div className="topPart">
                    <div className="left">
                        <div className="left-textModule1">
                            <TextModule cssStyle={guideStyle} data={guide} />
                        </div>
                        <TextModule cssStyle={titleStyle} data={title} />
                    </div>
                    <div className="right">
                        <TextModule cssStyle={descStyle} data={desc} />
                    </div>
                </div>
                <div className="bottomPart">
                    <ul className="sellLists">
                        {items.map((item: any, k: number) => (
                            <li
                                className="list"
                                key={k}
                                style={{
                                    width: items.length === 2 ? '480px' : '336px',
                                    marginLeft: k === 0 ? '0' : items.length === 2 ? '120px' : '56px',
                                }}
                            >
                                <TextIconCell cssStyle={textIconStyle} data={item} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
